<div @triggerChildAnimation>
  <div *ngIf="type === ToastType.PUSH_NOTIFICATION" class="push-notification" @slideIn @slideOut>
    <div
      *ngIf="isNotificationReferenceAvailable(); else pushNotificationSimpleHeader"
      class="push-notification__header clickable"
      (click)="redirectToNotificationDetails()"
      (keydown.enter)="redirectToNotificationDetails()"
    >
      <span class="header-content">
        {{ header }}
      </span>
    </div>

    <div class="push-notification__content-box">
      <div>
        <span class="push-notification__message" [innerHTML]="message"></span>
      </div>
      <div class="push-notification__dismiss-container">
        <a
          class="push-notification__dismiss-btn"
          [attr.aria-label]="'translations.global.button.dismiss' | transloco"
          (click)="dissmiss(true)"
          (keydown.enter)="dissmiss(true)"
        >
          {{ 'translations.global.button.dismiss' | transloco }}
        </a>
      </div>
    </div>
  </div>
  <ptl-toast
    *ngIf="type !== ToastType.PUSH_NOTIFICATION"
    [message]="message"
    [type]="type === ToastType.SUCCESS ? 'success' : 'error'"
    [closeAriaLabel]="'translations.global.button.dismiss' | transloco"
    (closed)="dissmiss(true)"
    @slideIn
    @slideOut
  ></ptl-toast>
</div>

<ng-template #pushNotificationSimpleHeader>
  <div class="push-notification__header">
    <span class="header-content">
      {{ header }}
    </span>
  </div>
</ng-template>
